import React from "react";
import PageHeader from "../Components/Pageheader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import {
  about1,
  about2,
  clockimg,
  icon1,
  icon2,
  icon3,
} from "../Constant/Index";
import "../assets/Css/about.css";
import { Link } from "react-router-dom";

function About() {
  return (
    <>
      <Header />
      <PageHeader pagename="About Us" />

      {/* Section one  */}
      <section className="spiritual-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="sec-one-img">
                <img src={about1} className="img-fluid" alt="about-img" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="spritual-sec-stuff">
                <span className="secondary-color">our story</span>
                <h3 className="primary-color">
                  Empowering Spiritual Journeys Discover the Essence of Powerful
                  Hand
                </h3>
                <p className="extra-color-6">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </p>

                <div className="spiritual-btn">
                <Link to="/shop">
                <button className="btn-all" style={{ width: "25%" }}>
                    shop now
                  </button>
                </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* =================== */}

      {/* Section two  */}
      <section className="spiritual-sec tracing-sec extra-color-6">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="spritual-sec-stuff">
                <span className="secondary-color">History</span>
                <h3 className="primary-color">
                  Tracing the Path The Journey of Powerful Hand in Nurturing
                  Spiritual Connections
                </h3>
                <p className="extra-color-6">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam
                </p>
              </div>

              <div className="about-tabs">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-home-tab"
                      data-toggle="pill"
                      data-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      2002
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-profile-tab"
                      data-toggle="pill"
                      data-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      2005
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-contact-tab"
                      data-toggle="pill"
                      data-target="#pills-contact"
                      type="button"
                      role="tab"
                      aria-controls="pills-contact"
                      aria-selected="false"
                    >
                      2010
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-year4-tab"
                      data-toggle="pill"
                      data-target="#pills-year4"
                      type="button"
                      role="tab"
                      aria-controls="pills-year4"
                      aria-selected="false"
                    >
                      2015
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-year5-tab"
                      data-toggle="pill"
                      data-target="#pills-year5"
                      type="button"
                      role="tab"
                      aria-controls="pills-year5"
                      aria-selected="false"
                    >
                      2020
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="spritual-sec-stuff">
                      <h3 className="primary-color">
                        the history of powerful hand
                      </h3>
                      <p className="extra-color-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam
                      </p>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="spritual-sec-stuff">
                      <h3 className="primary-color">
                        the history of powerful hand
                      </h3>
                      <p className="extra-color-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam
                      </p>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-contact-tab"
                  >
                    <div className="spritual-sec-stuff">
                      <h3 className="primary-color">
                        the history of powerful hand
                      </h3>
                      <p className="extra-color-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam
                      </p>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-year4"
                    role="tabpanel"
                    aria-labelledby="pills-year4-tab"
                  >
                    <div className="spritual-sec-stuff">
                      <h3 className="primary-color">
                        the history of powerful hand
                      </h3>
                      <p className="extra-color-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam
                      </p>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-year5"
                    role="tabpanel"
                    aria-labelledby="pills-year5-tab"
                  >
                    <div className="spritual-sec-stuff">
                      <h3 className="primary-color">
                        the history of powerful hand
                      </h3>
                      <p className="extra-color-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="sec-one-img">
                <img src={about2} className="img-fluid" alt="about-img" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* =================== */}

      {/* Section three  */}
      <section className="embrace-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="opening-hours">
                <div className="hours-head-dv">
                  <h3>opening hours</h3>
                  <img src={clockimg} alt="clock-img" className="img-fluid" />
                </div>

                <div className="day-date">
                  <span>monday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>tuesday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>wednesday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>thursday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>friday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>saturday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
                <div className="day-date">
                  <span>sunday</span>
                  <span>09:00am to 6:00pm</span>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="embrace-heading">
                <span className="secondary-color">about our stores</span>
                <h3 className="primary-color">
                  Embrace the Essence Locally Explore Our Stores in Brixton and
                  Birmingham
                </h3>
              </div>
              <div className="embrace-tabs">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-home-embrace-tab"
                      data-toggle="pill"
                      data-target="#pills-home-embrace"
                      type="button"
                      role="tab"
                      aria-controls="pills-home-embrace"
                      aria-selected="true"
                    >
                      Brixton Store
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-profile-tab-embrace"
                      data-toggle="pill"
                      data-target="#pills-profile-embrace"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile-embrace"
                      aria-selected="false"
                    >
                      birmingham store
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-home-embrace"
                    role="tabpanel"
                    aria-labelledby="pills-home-embrace-tab"
                  >
                    <div className="embrace-dv-all">
                      <div className="embrace-head">
                        <h3 className="primary-color">Brixton Store</h3>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 border_right">
                        <div className="icon-text">
                          <span>
                            <img src={icon1} alt="icon" className="img-fluid" />
                          </span>
                          <div className="dv-text">
                            <h3 className="primary-color">Phone Number:</h3>
                            <Link className="primary-color">
                              020 7738 3769
                            </Link>{" "}
                            <br />
                            <Link className="primary-color">078530 45785</Link>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 border_bottom">
                        <div className="icon-text">
                          <span>
                            <img src={icon2} alt="icon" className="img-fluid" />
                          </span>
                          <div className="dv-text">
                            <h3 className="primary-color">Address:</h3>
                            <p className="primary-color">
                              15 Electric Lane, Brixton, SW9 8LA, London,
                              England
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 border_right border_top">
                        <div className="icon-text">
                          <span>
                            <img src={icon3} alt="icon" className="img-fluid" />
                          </span>
                          <div className="dv-text">
                            <h3 className="primary-color">Email:</h3>
                            <p className="primary-color">
                            Powerfulhand@outlook.com
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="pills-profile-embrace"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab-embrace"
                  >
                    ...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ==================== */}
      <Footer />
    </>
  );
}

export default About;
